// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__jIYS9","spinner":"Spinner_spinner__dz8An","spin":"Spinner_spin__Ds2l6"};